import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useDeleteTreatmentPlan = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({
      treatmentId,
      patientId,
    }: {
      treatmentId: string;
      patientId: string;
    }) => {
      return api.delete(`treatments/${treatmentId}`);
    },
    onSuccess: (res, variables) => {
      // console.log(res.data);
      showSuccessNotification({
        title: "success",
        message: "delete-treatment-plan-success",
      });
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.treatmentPlanWithFilters(
          variables.patientId
        ),
      });
    },

    onError: (res, variables) => {
      console.error("[From Delete Treatment Plan]", res);
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.treatmentPlanWithFilters(
          variables.patientId
        ),
      });

      handleErrors(res, "mutation");
    },
  });
};
